<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Default</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-collapse accordion>
              <vs-collapse-item>
                <div slot="header">Collapse item</div>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                rhoncus eros tortor, non fringilla lectus cursus et. Fusce vel
                nisi ante. Aliquam sit amet lectus pharetra, luctus mi sed,
                aliquet felis. Mauris a tortor viverra, ornare tellus in,
                consectetur leo.
                <br /><br />
                Etiam nec nunc nec nisl luctus tincidunt efficitur vitae elit.
                Vestibulum iaculis nibh commodo neque ultrices lobortis. Cras
                magna massa, pretium vitae mattis varius, pharetra nec massa.
                Aliquam ac ex enim. Quisque consequat dui libero, vel blandit
                lorem porttitor sit amet. Vestibulum ante ipsum primis in
                faucibus orci luctus et ultrices posuere cubilia Curae; Nullam
                sed lobortis nisl, quis eleifend metus.
              </vs-collapse-item>
              <vs-collapse-item>
                <div slot="header">Collapse item 2</div>
                Nunc auctor et leo vitae suscipit. Nullam aliquet purus
                scelerisque enim hendrerit tristique. Maecenas tincidunt dui
                arcu, a aliquet nisl venenatis vitae. Praesent mauris ligula,
                porta at maximus ac, rutrum vitae sapien. Donec a sapien id erat
                dapibus dignissim sodales in est. Donec gravida dapibus sapien
                at sollicitudin. Maecenas iaculis quam ex,
                <br /><br />
                eu aliquam erat sagittis eget. Suspendisse mollis felis nec
                ipsum vehicula, at posuere libero viverra. Nam hendrerit dapibus
                eleifend. Aliquam elit nulla, tincidunt pellentesque enim
                mollis, consectetur placerat enim. Integer condimentum tristique
                ante et ullamcorper. Mauris placerat pretium ex. Nam aliquam sed
                tortor sit amet
                <br /><br />
                efficitur. Mauris quis faucibus nulla. Pellentesque egestas non
                ipsum vel maximus.
              </vs-collapse-item>
              <vs-collapse-item>
                <div slot="header">Collapse item 3</div>
                Suspendisse aliquet condimentum diam, sed aliquam nisl dapibus
                et. Aliquam euismod ullamcorper dolor eu
              </vs-collapse-item>
              <vs-collapse-item>
                <div slot="header">Collapse item 4</div>
                Suspendisse aliquet condimentum diam, sed aliquam nisl dapibus
                et. Aliquam euismod ullamcorper dolor eu imperdiet. Nullam eget
                odio at magna gravida suscipit sed vestibulum odio. Maecenas
                porta elit vel lectus molestie, eget aliquam enim feugiat.
                Vivamus nec faucibus nisl. Nunc venenatis tempus finibus.
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Icon</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-collapse>
              <vs-collapse-item icon-arrow="label">
                <div slot="header">Collapse item</div>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                rhoncus eros tortor, non fringilla lectus cursus et. Fusce vel
                nisi ante. Aliquam sit amet lectus pharetra, luctus mi sed,
                aliquet felis. Mauris a tortor viverra, ornare tellus in,
                consectetur leo.
                <br /><br />
                Etiam nec nunc nec nisl luctus tincidunt efficitur vitae elit.
                Vestibulum iaculis nibh commodo neque ultrices lobortis. Cras
                magna massa, pretium vitae mattis varius, pharetra nec massa.
                Aliquam ac ex enim. Quisque consequat dui libero, vel blandit
                lorem porttitor sit amet. Vestibulum ante ipsum primis in
                faucibus orci luctus et ultrices posuere cubilia Curae; Nullam
                sed lobortis nisl, quis eleifend metus.
              </vs-collapse-item>
              <vs-collapse-item icon-arrow="grade">
                <div slot="header">Collapse item 2</div>
                Nunc auctor et leo vitae suscipit. Nullam aliquet purus
                scelerisque enim hendrerit tristique. Maecenas tincidunt dui
                arcu, a aliquet nisl venenatis vitae. Praesent mauris ligula,
                porta at maximus ac, rutrum vitae sapien. Donec a sapien id erat
                dapibus dignissim sodales in est. Donec gravida dapibus sapien
                at sollicitudin. Maecenas iaculis quam ex,
                <br /><br />
                eu aliquam erat sagittis eget. Suspendisse mollis felis nec
                ipsum vehicula, at posuere libero viverra. Nam hendrerit dapibus
                eleifend. Aliquam elit nulla, tincidunt pellentesque enim
                mollis, consectetur placerat enim. Integer condimentum tristique
                ante et ullamcorper. Mauris placerat pretium ex. Nam aliquam sed
                tortor sit amet
                <br /><br />
                efficitur. Mauris quis faucibus nulla. Pellentesque egestas non
                ipsum vel maximus.
              </vs-collapse-item>
              <vs-collapse-item disabled icon-arrow="arrow_downward">
                <div slot="header">Collapse item 3 - Disabled</div>
                Suspendisse aliquet condimentum diam, sed aliquam nisl dapibus
                et. Aliquam euismod ullamcorper dolor eu
              </vs-collapse-item>
              <vs-collapse-item icon-arrow="arrow_drop_down">
                <div slot="header">Collapse item 4</div>
                Suspendisse aliquet condimentum diam, sed aliquam nisl dapibus
                et. Aliquam euismod ullamcorper dolor eu imperdiet. Nullam eget
                odio at magna gravida suscipit sed vestibulum odio. Maecenas
                porta elit vel lectus molestie, eget aliquam enim feugiat.
                Vivamus nec faucibus nisl. Nunc venenatis tempus finibus.
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({ colorx: "#c72a75", colorx2: "#5252e8" }),
};
</script>